import { render, staticRenderFns } from "./payment-group-orders.vue?vue&type=template&id=396345e4&scoped=true&"
import script from "./payment-group-orders.js?vue&type=script&lang=js&"
export * from "./payment-group-orders.js?vue&type=script&lang=js&"
import style0 from "./payment-group-orders.scss?vue&type=style&index=0&id=396345e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396345e4",
  null
  
)

export default component.exports